export const GENERAL_QUESTION_SETTINGS = {
    name: "",
    type: "",
    collector: "",
    label: "Question label",
    hint: "Question hint",
    display: [],
    question_appearance_value:{},
    appearance: "",
    searches: "",
    readonly: false,
    readonly_custom_expr: false, // using custom expression instead of true/false
    disabled_custom_expr: false, // using custom expression instead of true/false
    required_custom_expr: false,
    disabled: false,
    required: false,
    required_message: "",
    constraint: "",
    constraint_message: "",
    relevant: "",
    gridformat: {},
    default: "",
    choice: "",
    children: [],
    calculation: ""
};
